import { inject, injectable } from 'inversify';
import { QuadroLayoutStateStore, QuadroLayoutType } from './QuadroLayoutState.store';
import { TYPES } from '@/engine/ioc';

@injectable()
export class QuadroLayoutController {
  private readonly _quadroLayoutStateStore: QuadroLayoutStateStore;

  public constructor(@inject(TYPES.QuadroLayoutStateStore) quadroLayoutStateStore: QuadroLayoutStateStore) {
    this._quadroLayoutStateStore = quadroLayoutStateStore;
  }

  public get activeQuadroLayoutType(): QuadroLayoutType {
    return this._quadroLayoutStateStore.activeQuadroLayoutType;
  }

  public setActiveQuadroLayoutType(layoutType: QuadroLayoutType): void {
    this._quadroLayoutStateStore.setActiveQuadroLayoutType(layoutType);
  }
}
